import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";

/* container */
import OrderContainer from "../../app-module-order-container/default";
/* container */

/* packages */
import {
  ModuleWrapperMd,
  ModuleWrapperXl,
} from "../../lib-atomic-design-section";
import { ModulePaperWrapper } from "../../lib-atomic-design-section";
import {
  ModuleTitle,
  ModuleLink,
  ModuleText,
  ModuleImage,
} from "../../lib-atomic-design-section";
import { LocalStorage } from "../../lib-atomic-functions";
import { FetchContextApi } from "../../lib-atomic-functions";
/* packages */

/* modules */
import Loader from "../loader/orders";
import OrdersListing from "../list/orders";
/* modules */

/* section */
import Nav from "../section/nav";
import Title from "../section/title";
import Action from "../section/action";
/* section */

/* stores */
import { OrderList } from "../../app-module-order-container/stores";
/* stores */

import CONFIG from "../config";

/* CONSTANTS */
const SAVEAS = require("file-saver");
const LANDINGGRAPHICS = CONFIG.setup.assets.landing.default;
const LIST = CONFIG.application.order.api.endpoints.list;
const LISTCONFIG = {
  url: LIST.url,
  method: LIST.method,
  headers: LIST.headers,
  responseType: "json",
};
// ponytail: click-and-collect only (deliveryMethodId === 2, as used in
// order-page-detail/section/action.js) and never ONHOLD. Applied here rather
// than in list/orders.js so every section below the fetch sees the same set.
export const CLICK_AND_COLLECT = 2;

// Hidden statuses live in app-conf/westfield/setup-uat.js so adding one is a
// config edit. The row field is orderStatusId; `statusId` is only the /orders
// query param. Stringified compare so "2" and 2 both match.
export const HIDDEN_STATUS = (CONFIG.setup.setup.hideOrderStatus || []).map(
  Number
);

const isHiddenStatus = (o) =>
  HIDDEN_STATUS.includes(Number(o.orderStatusId));

// Store scoping. Map lives in app-conf/westfield/setup-uat.js so adding a store
// is one line there, not a code change here.
const SCOPES = CONFIG.setup.setup.orderScope || {};

// Keys are normalised so the map can be written in any case.
const BY_USERNAME = Object.keys(SCOPES).reduce((acc, key) => {
  acc[key.toLowerCase()] = SCOPES[key];
  return acc;
}, {});

export const scopeFor = (username) =>
  BY_USERNAME[String(username || "").toLowerCase()] || false;

// Exact match, not substring: `match` is a store id, and a substring compare
// would let store 3228 swallow 32280254. Stringified so a numeric id in the
// config still matches a string id in the payload. An order missing the field
// fails closed.
export const inScope = (order, scope) =>
  !scope ||
  String(order[scope.field]).toLowerCase() === String(scope.match).toLowerCase();

export const visibleOrders = (orders, scope) =>
  (orders || []).filter(
    (o) =>
      o.deliveryMethodId === CLICK_AND_COLLECT &&
      !isHiddenStatus(o) &&
      inScope(o, scope),
  );
/* CONSTANTS */

const index = observer((props) => {
  const { token, username } = LocalStorage.getLS().login;
  const scope = scopeFor(username);

  /* state */
  LISTCONFIG.headers = { ...LISTCONFIG.headers, Authorization: token };
  const [orderListContext, orderListMethod] = FetchContextApi(
    LISTCONFIG,
    OrderList,
  );

  useEffect(() => {
    orderListMethod({});
  }, []);
  /* state */

  /* data props */
  const listData = {
    props,
    ...orderListContext.data,
    order: visibleOrders(
      orderListContext.data && orderListContext.data.order,
      scope,
    ),
  };
  /* data props */

  /* data loader */
  if (orderListContext.loading || !orderListContext.data) {
    return (
      <OrderContainer {...props}>
        <Loader />
      </OrderContainer>
    );
  }
  /* data loader */

  return (
    <OrderContainer {...props}>
      <ModuleWrapperXl>
        <Nav {...props} />
        <Title {...props} />
        <Action {...listData} />
      </ModuleWrapperXl>

      <ModuleWrapperMd>
        <OrdersListing {...listData} />
      </ModuleWrapperMd>
    </OrderContainer>
  );
});

export default index;
